export const verifyProcess = (paymentData) => {
    if (paymentData?.zone?.value?.toString()?.length < 1) {
        return false;
    }
    return true;
};

export const pageActivator = (page, paymentData, paymentDataSetter) => {
    const updatedPaymentData = { ...paymentData }; // Create a copy of paymentData to avoid mutation
    for (const key in updatedPaymentData) {
        if (key === page) {
            updatedPaymentData[key].status = true;
        } else {
            updatedPaymentData[key].status = false;
        }
    }
    paymentDataSetter(updatedPaymentData);
};
